export default __webpack_public_path__ + "static/media/Zone-Master-Plan-Type-D.de924d93.png";